import { render, staticRenderFns } from "./type_3.vue?vue&type=template&id=5eb7534d&scoped=true"
import script from "./type_3.vue?vue&type=script&lang=js"
export * from "./type_3.vue?vue&type=script&lang=js"
import style0 from "./type_3.vue?vue&type=style&index=0&id=5eb7534d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb7534d",
  null
  
)

export default component.exports